import React from 'react';
import { Button } from 'antd';
import st from './styles.module.scss';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';

const AuthButtons = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const isEmployeesPage = location.pathname === '/';
  const isEmployersPage = location.pathname === '/employers';

  const onClickOpenLoginEmployeesPage = () => {
    window.open(`https://m-career.uwed.uz/login?lng=${currentLanguage}`, '_blank');
  };
  const onClickOpenSignUpEmployeesPage = () => {
    window.open('https://m-career.uwed.uz/sign-up', '_blank');
  };
  const onClickOpenLoginEmployersPage = () => {
    window.open(`https://hr-career.uwed.uz?lng=${currentLanguage}`, '_blank');
  };
  const onClickOpenSignUpEmployersPage = () => {
    window.open(`https://hr-career.uwed.uz/signup?lng=${currentLanguage}`, '_blank');
  };
  return (
    <>
      {isEmployeesPage && (
        <>
          {/*<Button className={st.signBtn} onClick={onClickOpenSignUpEmployeesPage}>*/}
          {/*  {t('Signup')}*/}
          {/*</Button>*/}
          <Button className={st.signBtn} onClick={onClickOpenLoginEmployeesPage}>
            {t('Login')}
          </Button>
        </>
      )}
      {isEmployersPage && (
        <>
          <Button className={st.signBtn} onClick={onClickOpenSignUpEmployersPage}>
            {t('Signup')}
          </Button>
          <Button className={st.signBtn} onClick={onClickOpenLoginEmployersPage}>
            {t('Login')}
          </Button>
        </>
      )}
    </>
  );
};

export default AuthButtons;
